// extracted by mini-css-extract-plugin
export default {"actionButton":"actionButton--HAAxv","dialogTitle":"dialogTitle--a41U2","dialogContent":"dialogContent--W22ZT","table":"table--gX53U"};